import { GetTodaysDateINdmy } from "../../../../CommonFunction/GetTodaysDate";

export const Reference = {
  [Math.random() * 10]: [
    {
      id: Math.random() * 10,
      name: "Type",
      Input: true,
      type: "inputdrop",
      dropdowndata: ["New Reference", "Against Ref", "On Account"],
      value: "",
      notSearchable: true,
    },
    {
      id: Math.random() * 10,
      name: "Particular",
      Input: true,
      type: "text",
      value: "",
    },
    {
      id: Math.random() * 10,
      name: "RefDate",
      Input: true,
      type: "Date",
      value: GetTodaysDateINdmy(),
    },
    {
      id: Math.random() * 10,
      name: "Amount",
      Input: true,
      type: "number",
      value: 0,
    },
    {
      id: Math.random() * 10,
      name: "TransactionType",
      Input: true,
      type: "inputdrop",
      dropdowndata: ["Credit", "Debit"],
      value: "",
    },
    {
      id: Math.random() * 10,
      name: "Unique_Id",
      Input: true,
      type: "text",
      value: "",
      disabled: true,
    },
  ],
};

export const initialRef = [
  {
    id: Math.random() * 10,
    name: "Type",
    Input: true,
    type: "inputdrop",
    dropdowndata: ["New Reference", "Against Ref", "On Account"],
    value: "",
    notSearchable: true,
  },
  {
    id: Math.random() * 10,
    name: "Particular",
    Input: true,
    type: "text",
    value: "",
  },
  {
    id: Math.random() * 10,
    name: "RefDate",
    Input: true,
    type: "Date",
    value: GetTodaysDateINdmy(),
  },
  {
    id: Math.random() * 10,
    name: "Unique_Id",
    Input: true,
    type: "text",
    value: "",
    disabled: true,
  },
];
export let AmountDetails = {
  id: Math.random() * 10,
  name: "Amount",
  Input: true,
  type: "number",
  value: 0,
};
export let TransactionTypeDetails = {
  id: Math.random() * 10,
  name: "TransactionType",
  Input: true,
  type: "inputdrop",
  dropdowndata: ["Credit", "Debit"],
  value: "",
  notSearchable: true,
};

export const initialRefForNewRef = [
  {
    id: Math.random() * 10,
    name: "Type",
    Input: true,
    type: "inputdrop",
    dropdowndata: ["New Reference", "Against Ref", "On Account"],
    value: "",
    notSearchable: true,
  },
  {
    id: Math.random() * 10,
    name: "Particular",
    Input: true,
    type: "text",
    value: "",
  },
  {
    id: Math.random() * 10,
    name: "RefDate",
    Input: true,
    type: "Date",
    value: GetTodaysDateINdmy(),
  },
  {
    id: Math.random() * 10,
    name: "Amount",
    Input: true,
    type: "number",
    value: 0,
  },
  {
    id: Math.random() * 10,
    name: "TransactionType",
    Input: true,
    type: "inputdrop",
    dropdowndata: ["Credit", "Debit"],
    value: "",
    notSearchable: true,
  },
  {
    id: Math.random() * 10,
    name: "Unique_Id",
    Input: true,
    type: "text",
    value: "",
    disabled: true,
  },
];
